export const products = [
  {
    "id": "9f6653e0-a260-43db-a694-b73b8b276449",
      "name": "Авокадо маки **",
      "description": "Свежий авокадо и ничего лишнего",
      "price": 0,
      "image": "/img/avokado_maki.PNG",
    "code": 1000
  },
  {
    "id": "9f6653e0-a26d-49a6-acf9-59c7462d07a4",
      "name": "Аге гурме **",
      "description": "Лосось жареный, сыр сливочный, огурец, соус масаго",
      "price": 0,
      "image": "/img/age_gurme.PNG",
      "code": 1001
  },
  {
    "id": "9f6653e0-a271-49d9-aaa2-a74a63eefbaa",
      "name": "Аляска кунсей **",
      "description": "Лосось копченый, сыр сливочный, огурец, кунжут",
      "price": 0,
      "image": "/img/alaska_kunsei.PNG",
      "code": 1003
  },
  {
    "id": "9f6653e0-a274-42ad-90cf-b422c509279b",
    "name": "Благородный сёгун **",
      "description": "Снежный краб, лосось копченый, сыр сливочный, помидор, соус унаги, микрозелень",
    "price": 0,
    "image": "/img/seegun.PNG",
    "code": 1004
  },
  {
    "id": "fbb90cee-c3fd-47d7-a555-484816979bbd",
    "name": "Бонито мидии **",
      "description": "Мидии, сыр сливочный, помидор, стружка тунца",
    "price": 0,
    "image": "/img/.png",
    "code": 1056
  },
  {
    "id": "2d11f371-8a0c-46d1-9da1-22180a4fb421",
    "name": "Бонито тунец **",
      "description": "Тунец, сыр сливочный, помидор, стружка тунца",
    "price": 0,
    "image": "/img/.png",
    "code": 1057
  },
  {
    "id": "dac7752b-c858-4a84-b404-70753dea26f1",
    "name": "Бруклин **",
      "description": "Лосось копченый, сыр сливочный, огурец",
    "price": 0,
    "image": "/img/.png",
    "code": 1006
  },
  {
    "id": "09ee4722-9c93-4692-973e-5fca059f6131",
    "name": "Горячий дон жуан **",
      "description": "Лосось жареный, шапка краб, лук зеленый, помидор, соус унаги, кунжут",
    "price": 0,
    "image": "/img/.png",
    "code": 1008
  },
  {
    "id": "fa815f1a-c56a-4bc6-b0b6-38b946cb3d2e",
    "name": "Детройт **",
      "description": "Лосось, огурец, сыр сливочный",
    "price": 0,
    "image": "/img/.png",
    "code": 1010
  },
  {
    "id": "9f6653e0-a276-48ae-8285-f605f86aefad",
    "name": "Запеченный лосось файр **",
      "description": "Лосось жареный, сыр сливочный, шапка с лососем, томаго, соус унаги, кунжут",
    "price": 0,
    "image": "/img/losos_fair.PNG",
    "code": 1005
  },
  {
    "id": "9f6653e0-a288-4c36-8494-f1c052072786",
    "name": "Запеченный мидзуи **",
      "description": "Мидии, сыр сливочный, шапка с лососем, шапка с мидиями, томаго, соус унаги, соус свит чили, кунжут",
    "price": 0,
    "image": "/public/img/miduei(1).PNG",
    "code": 1012
  },
  {
    "id": "9f6653e0-a28d-41c4-95af-26c9e7aa7ad9",
    "name": "Запеченный ролл с беконом **",
      "description": "Бекон, сыр чеддер, курица, помидор",
    "price": 0,
    "image": "/public/img/roll_s_bekonom.PNG",
    "code": 1014
  },
  {
    "id": "9fa8b803-192d-45a8-9067-6f429772d721",
    "name": "Запеченный тори ролл **",
      "description": "Курица, помидор, лист салата, сыр моцарелла, шапка курицы, соус терияки, кунжут",
    "price": 0,
    "image": "/public/img/tori_roll.PNG",
    "code": 1059
  },
  {
    "id": "9f6653e0-a28f-4c1e-b4ac-e89b58a15174",
      "name": "Калифорния **",
      "description": "Снежный краб, огурец, авокадо, икра масаго, майонез",
      "price": 0,
      "image": "/img/kalifornia.PNG",
    "code": 1015
  },
  {
    "id": "9f6653e0-a292-4040-b788-7a212640e041",
      "name": "Кани гриль **",
      "description": "Снежный краб, сыр сливочный, шапка с крабом, томаго, соус унаги, кунжут",
      "price": 0,
      "image": "/img/kani_gril.PNG",
    "code": 1016
  },
  {
    "id": "9f6653e0-a294-4f24-a569-acfaaef8c4fc",
      "name": "Каппа маки **",
      "description": "Огурец",
      "price": 0,
      "image": "/img/kappa_maki.PNG",
    "code": 1017
  },
  {
    "id": "9f6653e0-a297-4dbd-967e-a40f4cbae028",
      "name": "Краб дуэт гриль **",
      "description": "Снежный краб, мидии, шапка с крабом, шапка с мидиями, сыр моцарелла, соус спайси, соус унаги, кунжут",
      "price": 0,
      "image": "/img/krab_duet.PNG",
    "code": 1018
  },
  {
    "id": "9f6653e0-a29e-473f-94ee-f7aeb0ff9e25",
      "name": "Манхеттен **",
      "description": "Креветка, сыр сливочный, икра масаго",
      "price": 0,
      "image": "/img/manheten.PNG",
    "code": 1021
  },
  {
    "id": "9f6653e0-a299-4b4c-8876-0e53f4a21263",
      "name": "Мидии маки гриль **",
      "description": "Мидии, шапка с мидиями, томаго, сыр сливочный, соус унаги, кунжут",
      "price": 0,
      "image": "/img/midii_maki_gril.PNG",
    "code": 1019
  },
  {
    "id": "9fa8b803-1934-413a-b034-1e3fd30c6190",
      "name": "Мидии терияки **",
      "description": "Мидии пряные, сыр сливочный, томаго, соус такемура, кунжут, микрозелень",
      "price": 0,
      "image": "/img/midii_teriaki.PNG",
    "code": 1062
  },
  {
    "id": "9f6653e0-a2a3-44d7-8bee-7a20eb62ff6e",
      "name": "Ниагара **",
      "description": "Шапка с лососем, помидор, томаго, лук зеленый, лист салата, соус унаги, кунжут",
      "price": 0,
      "image": "/img/niagara.PNG",
    "code": 1023
  },
  {
    "id": "9f6653e0-a2a8-4120-a6b3-35607501f344",
      "name": "Розовый **",
      "description": "Лосось, сыр сливочный, помидор, соус масаго",
      "price": 0,
      "image": "/img/pink.PNG",
    "code": 1025
  },
  {
    "id": "9fa8b803-1939-4ab7-b23f-9481bb1413fa",
    "name": "Сказочный тунец **",
      "description": "Тунец, сыр сливочный, огурец, соус терияки, соус такемура, кунжут, микрозелень",
    "price": 0,
    "image": "/public/img/",
    "code": 1063
  },
  {
    "id": "9f6653e0-a2ac-40c5-a0f2-a9f6a01ca393",
    "name": "Спайси эби маки **",
      "description": "Креветки, соус спайси",
    "price": 0,
    "image": "/img/.png",
    "code": 1027
  },
  {
    "id": "9f6653e0-a2b8-41f1-aecd-1ca3f29e6021",
    "name": "Суши-сэндвич с лососем **",
    "description": "Лосось, сыр сливочный, икра масаго, лист салат, кунжут",
    "price": 0,
    "image": "/img/.png",
    "code": 1032
  },
  {
    "id": "8d69de7f-9d9d-40ca-b975-0c2b6a8c2617",
    "name": "Сяке кунсей маки **",
      "description": "Лосось копченый, икра масаго",
    "price": 0,
    "image": "/img/.png",
    "code": 1034
  },
  {
    "id": "db0d44eb-e5ba-4714-a221-c8ca153f5e04",
    "name": "Сяке маки **",
      "description": "Лосось",
    "price": 0,
    "image": "/img/.png",
    "code": 1035
  },
  {
    "id": "62c23f9d-9525-4b4f-b27a-2d0358bb451e",
    "name": "Сяке хот **",
      "description": "Шапка лосось, сыр сливочный, огурец, томаго, соус терияки, кунжут",
    "price": 0,
    "image": "/img/.png",
    "code": 1064
  },
  {
    "id": "f048a431-19fd-48e3-89f8-8caf45a1d2c5",
    "name": "Туна маки **",
      "description": "Тунец",
    "price": 0,
    "image": "/img/.png",
    "code": 1037
  },
  {
    "id": "735e6e4d-1993-480a-bd91-bfa85569b57d",
    "name": "Унаги маки **",
      "description": "Угорь жареный, огурец, соус унаги, кунжут",
    "price": 0,
    "image": "/img/.png",
    "code": 1038
  },
  {
    "id": "927e11f6-4139-4d43-b381-8f39152e63e8",
    "name": "Филадельфия лайт с огурцом **",
      "description": "Лосось, сыр сливочный, огурец",
    "price": 0,
    "image": "/img/.png",
    "code": 1040
  },
  {
    "id": "8e622900-941d-43b6-9e8a-d7165d25d33f",
    "name": "Фреш ролл **",
      "description": "Помидор, лист салата, сыр сливочный, кунжут.",
    "price": 0,
    "image": "/img/.png",
    "code": 1042
  },
  {
    "id": "c3b06128-cb58-45b0-ab86-9830f31359e0",
    "name": "Чеддер скин ролл **",
      "description": "Лосось, грибы шиитаке, сыр сливочный, лист салата, сыр чеддер, соус манго, микрозелень",
    "price": 0,
    "image": "/img/.png",
    "code": 1066
  },
  {
    "id": "a3fcc907-a059-44c7-9ef1-10e4bbea22b4",
    "name": "Чизи эби **",
      "description": "Креветки, огурец, сыр сливочный, сыр чеддер, кунжут",
    "price": 0,
    "image": "/img/.png",
    "code": 1067
  },
  {
    "id": "3c842fd8-0401-4bd2-88b9-f194bd55c6f5",
    "name": "Чука маки **",
      "description": "Чука, соус ореховый",
    "price": 0,
    "image": "/img/.png",
    "code": 1046
  },
  {
    "id": "a1894c5f-42c0-42bb-ab66-6f056bcacb65",
    "name": "Шёлковый путь **",
      "description": "Курица, сыр сливочный, помидор, соус такемура, микрозелень, кунжут",
    "price": 0,
    "image": "/img/e.png",
    "code": 1048
  }
];
